/* esm.sh - unhead@2.1.12/utils */
export * from "/*unhead@2.1.12/esnext/utils.mjs";
